export function readErrorId() {
  const errorId = typeof window === "undefined" ? null : window?.blclient?.data?.errorId;
  return errorId == null ? "" : String(errorId);
}
